import { call, put, select, all, takeLatest } from 'redux-saga/effects';
import { userActionTypes as types } from 'src/redux/actions/userActions';
import { getDatabase, ref, child, get } from "firebase/database";
import notification from 'src/utils/notification';

function* fetchUsers({ payload, callback }) {
  try {
    const dbRef = ref(getDatabase());
    const data = yield get(child(dbRef, `users`));
    if (!data.exists()) {
      throw new Error('No data!');
    }
    yield put({ type: types.FETCH_USERS_SUCCESS, data: data.val() });
    notification.close();
    callback?.();
  } catch (error) {
    yield put({ type: types.FETCH_USERS_FAILURE, error });
    console.error(error);
    notification.showError(error.message);
  }
}

export default function* userSaga() {
  yield all([
    takeLatest(types.FETCH_USERS_REQUEST, fetchUsers),
  ])
}
